import { StatusBadge } from '@/components/ui/status-badge'
import { PriorityBadge } from '@/components/ui/priority-badge'
import type { TaskResponse } from '@/types/task'

function getDueDateClass(dueDate: string | null): string {
  if (!dueDate) return 'text-muted-foreground'
  const today = new Date().toISOString().slice(0, 10)
  if (dueDate < today) return 'text-red-600 font-medium'
  if (dueDate === today) return 'text-orange-500 font-medium'
  return 'text-muted-foreground'
}

function formatDate(date: string): string {
  return new Date(date).toLocaleDateString('id-ID', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  })
}

interface TaskListViewProps {
  tasks: TaskResponse[]
  onTaskClick: (id: string) => void
}

export function TaskListView({ tasks, onTaskClick }: TaskListViewProps) {
  return (
    <div className="overflow-x-auto rounded-xl border border-border">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-border bg-muted/50">
            <th className="px-4 py-2.5 text-left font-medium text-muted-foreground">Judul</th>
            <th className="px-4 py-2.5 text-left font-medium text-muted-foreground">Status</th>
            <th className="px-4 py-2.5 text-left font-medium text-muted-foreground">Prioritas</th>
            <th className="px-4 py-2.5 text-left font-medium text-muted-foreground">Due Date</th>
            <th className="px-4 py-2.5 text-left font-medium text-muted-foreground">Assignee</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-border">
          {tasks.map((task) => (
            <tr
              key={task.id}
              onClick={() => onTaskClick(task.id)}
              className="cursor-pointer transition-colors hover:bg-secondary"
            >
              <td className="px-4 py-2.5 font-medium">{task.title}</td>
              <td className="px-4 py-2.5">
                <StatusBadge name={task.status_name} color={task.status_color} />
              </td>
              <td className="px-4 py-2.5">
                <PriorityBadge priority={task.priority} />
              </td>
              <td className={`px-4 py-2.5 text-xs ${getDueDateClass(task.due_date)}`}>
                {task.due_date ? formatDate(task.due_date) : '—'}
              </td>
              <td className="px-4 py-2.5">
                {task.assignee_name ? (
                  <span className="inline-flex items-center gap-1.5 text-xs text-muted-foreground">
                    {task.assignee_avatar ? (
                      <img
                        src={task.assignee_avatar}
                        alt={task.assignee_name}
                        className="h-5 w-5 rounded-full object-cover"
                      />
                    ) : (
                      <span className="flex h-5 w-5 items-center justify-center rounded-full bg-muted text-[10px] font-medium">
                        {task.assignee_name.charAt(0).toUpperCase()}
                      </span>
                    )}
                    {task.assignee_name}
                  </span>
                ) : (
                  <span className="text-xs text-muted-foreground">—</span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
